import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { FaUpload } from '@react-icons/all-files/fa/FaUpload';
import { FaCheck } from 'react-icons/fa';

import Button from '../../../../components/ui/buttons/Button';
import { DealMediaTypeEnum } from '../../../../gql/generated/graphql';
import { PriorityDoc } from './utils';

type Props = {
  doc: PriorityDoc;
  uploadedTypes: Set<DealMediaTypeEnum>;
  onUpload: (doc: PriorityDoc) => void;
};

const SideStatus = ({ label, uploaded }: { label: string; uploaded: boolean }) => (
  <Flex align="center" gap={1}>
    {uploaded && <Icon as={FaCheck} boxSize={3} color="green.300" />}
    <Text fontSize="12px" color={uploaded ? 'green.500' : 'gray.500'}>
      {label}
    </Text>
  </Flex>
);

const PriorityDocRow = ({ doc, uploadedTypes, onUpload }: Props) => (
  <Box mb={4}>
    <Flex flexDir="column" justify="space-between" align="flex-start" mb={2} gap={1}>
      <Text fontSize="14px" fontWeight="bold" color="leaseEndBlue">
        {doc.label}
      </Text>
      {doc.back ? (
        <Flex gap={1}>
          <SideStatus label="Front" uploaded={uploadedTypes.has(doc.front)} />
          <Text fontSize="xs" opacity={0.3}>
            |
          </Text>
          <SideStatus label="Back" uploaded={uploadedTypes.has(doc.back)} />
        </Flex>
      ) : (
        <SideStatus
          label={uploadedTypes.has(doc.front) ? 'Uploaded' : 'Not uploaded'}
          uploaded={uploadedTypes.has(doc.front)}
        />
      )}
    </Flex>
    <Button
      variant="secondaryFilled"
      size="sm"
      w="100%"
      leftIcon={<Icon as={FaUpload} boxSize="12px" />}
      onClick={() => onUpload(doc)}
    >
      <Text as="span" fontSize="sm">
        UPLOAD
      </Text>
    </Button>
  </Box>
);

export default PriorityDocRow;
